/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateUserGroupRequestDto,
  CreateUserGroupResponseDto,
  GetUserGroupByIdResponseDto,
  GetUserGroupListPaginatedParams,
  GetUserGroupListPaginatedResponseDto,
  UpdateUserGroupRequestDto,
  UpdateUserGroupResponseDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Create a new user group
 */
export const createUserGroup = (
    createUserGroupRequestDto: CreateUserGroupRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<CreateUserGroupResponseDto>(
      {url: `/user-groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserGroupRequestDto, signal
    },
      options);
    }
  


export const getCreateUserGroupMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserGroup>>, TError,{data: CreateUserGroupRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createUserGroup>>, TError,{data: CreateUserGroupRequestDto}, TContext> => {

const mutationKey = ['createUserGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUserGroup>>, {data: CreateUserGroupRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  createUserGroup(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createUserGroup>>>
    export type CreateUserGroupMutationBody = CreateUserGroupRequestDto
    export type CreateUserGroupMutationError = null | null | null

    /**
 * @summary Create a new user group
 */
export const useCreateUserGroup = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUserGroup>>, TError,{data: CreateUserGroupRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUserGroup>>,
        TError,
        {data: CreateUserGroupRequestDto},
        TContext
      > => {

      const mutationOptions = getCreateUserGroupMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary List user groups for the organization
 */
export const getUserGroupListPaginated = (
    params: GetUserGroupListPaginatedParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserGroupListPaginatedResponseDto>(
      {url: `/user-groups`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetUserGroupListPaginatedQueryKey = (params?: GetUserGroupListPaginatedParams,) => {
    return [`/user-groups`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserGroupListPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError = null | null>(params: GetUserGroupListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGroupListPaginatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGroupListPaginated>>> = ({ signal }) => getUserGroupListPaginated(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserGroupListPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGroupListPaginated>>>
export type GetUserGroupListPaginatedQueryError = null | null


export function useGetUserGroupListPaginated<TData = Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError = null | null>(
 params: GetUserGroupListPaginatedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserGroupListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getUserGroupListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserGroupListPaginated<TData = Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError = null | null>(
 params: GetUserGroupListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserGroupListPaginated>>,
          TError,
          Awaited<ReturnType<typeof getUserGroupListPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserGroupListPaginated<TData = Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError = null | null>(
 params: GetUserGroupListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List user groups for the organization
 */

export function useGetUserGroupListPaginated<TData = Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError = null | null>(
 params: GetUserGroupListPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserGroupListPaginated>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUserGroupListPaginatedQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Find User Group by id
 */
export const findUserGroupById = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetUserGroupByIdResponseDto>(
      {url: `/user-groups/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getFindUserGroupByIdQueryKey = (id?: string,) => {
    return [`/user-groups/${id}`] as const;
    }

    
export const getFindUserGroupByIdQueryOptions = <TData = Awaited<ReturnType<typeof findUserGroupById>>, TError = null | null>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserGroupById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getFindUserGroupByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof findUserGroupById>>> = ({ signal }) => findUserGroupById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof findUserGroupById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type FindUserGroupByIdQueryResult = NonNullable<Awaited<ReturnType<typeof findUserGroupById>>>
export type FindUserGroupByIdQueryError = null | null


export function useFindUserGroupById<TData = Awaited<ReturnType<typeof findUserGroupById>>, TError = null | null>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserGroupById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findUserGroupById>>,
          TError,
          Awaited<ReturnType<typeof findUserGroupById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindUserGroupById<TData = Awaited<ReturnType<typeof findUserGroupById>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserGroupById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findUserGroupById>>,
          TError,
          Awaited<ReturnType<typeof findUserGroupById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useFindUserGroupById<TData = Awaited<ReturnType<typeof findUserGroupById>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserGroupById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Find User Group by id
 */

export function useFindUserGroupById<TData = Awaited<ReturnType<typeof findUserGroupById>>, TError = null | null>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof findUserGroupById>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFindUserGroupByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Delete User Group by id
 */
export const deleteUserGroupById = (
    id: string,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/user-groups/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteUserGroupByIdMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserGroupById>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserGroupById>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUserGroupById'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserGroupById>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUserGroupById(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserGroupByIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserGroupById>>>
    
    export type DeleteUserGroupByIdMutationError = null | null | null

    /**
 * @summary Delete User Group by id
 */
export const useDeleteUserGroupById = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserGroupById>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserGroupById>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUserGroupByIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Update User group
 */
export const updateUserGroup = (
    id: string,
    updateUserGroupRequestDto: UpdateUserGroupRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<UpdateUserGroupResponseDto>(
      {url: `/user-groups/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserGroupRequestDto
    },
      options);
    }
  


export const getUpdateUserGroupMutationOptions = <TError = null | null | null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserGroup>>, TError,{id: string;data: UpdateUserGroupRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateUserGroup>>, TError,{id: string;data: UpdateUserGroupRequestDto}, TContext> => {

const mutationKey = ['updateUserGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateUserGroup>>, {id: string;data: UpdateUserGroupRequestDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateUserGroup(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateUserGroup>>>
    export type UpdateUserGroupMutationBody = UpdateUserGroupRequestDto
    export type UpdateUserGroupMutationError = null | null | null | null | null

    /**
 * @summary Update User group
 */
export const useUpdateUserGroup = <TError = null | null | null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateUserGroup>>, TError,{id: string;data: UpdateUserGroupRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateUserGroup>>,
        TError,
        {id: string;data: UpdateUserGroupRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateUserGroupMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    